// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__d5ht3","description":"PatientConsentPreview_description__17qtq"};